
//公用图片
Vue.component("base_image", {
  props: {
      src: {
          type: String,
          required: true,
          default: ''
      },
      error_src: {
          type: String,
          default: ''
      },
      class_name: {
          type: String,
          default: ''
      }
  },
  data() {
      return {
          url: ''
      }
  },
  watch: {
    src: {
        handler(val) {
            this.url = val
        },
        immediate: true
    }
  },
//   mounted() {
//       this.url = this.src
//   },
  methods: {
      error() {
          this.url = this.error_src
      }
  },
  template: `
      <img
          :src="url"
          :class="class_name"
          @error="error"
          alt=""
          referrerpolicy="no-referrer"
      />`
});